// 防抖
export function debounce(func, delay) {
    let timeout;
    return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            func.apply(this, args);
        }, delay);
    };
}

// 節流
export function throttle(func, delay) {
    let lastTime = 0;
    return function (...args) {
        const now = Date.now();
        if (now - lastTime >= delay) {
            lastTime = now;
            func.apply(this, args);
        }
    };
}

// 檢查對象是否爲空
export function isEmptyObject(obj) {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
}

// 隨機數生成
export function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

// 格式化日期

export function formatDate(date, format = 'YYYY-MM-DD') {
    const map = {
        YYYY: date.getFullYear(),
        MM: ('0' + (date.getMonth() + 1)).slice(-2),
        DD: ('0' + date.getDate()).slice(-2),
        HH: ('0' + date.getHours()).slice(-2),
        mm: ('0' + date.getMinutes()).slice(-2),
        ss: ('0' + date.getSeconds()).slice(-2),
    };
    return format.replace(/YYYY|MM|DD|HH|mm|ss/gi, (matched) => map[matched]);
}

// 格式化貨幣
export function formatCurrency(value, currency = 'USD', locale = 'en-US') {
    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
    }).format(value);
}

// 數字千分化
export const format = (n) => {
    let num = n.toString();
    let len = num.length;
    if (len <= 3) {
        return num;
    } else {
        let temp = '';
        let remainder = len % 3;
        if (remainder > 0) {
            return num.slice(0, remainder) + ',' + num.slice(remainder, len).match(/\d{3}/g).join(',') + temp;
        } else {
            return num.slice(0, len).match(/\d{3}/g).join(',') + temp;
        }
    }
}

// 數字轉成大寫金額
export const digitUppercase = (n) => {
    const fraction = ['角', '分'];
    const digit = [
        '零', '壹', '贰', '叁', '肆',
        '伍', '陆', '柒', '捌', '玖'
    ];
    const unit = [
        ['元', '万', '亿'],
        ['', '拾', '佰', '仟']
    ];
    n = Math.abs(n);
    let s = '';
    for (let i = 0; i < fraction.length; i++) {
        s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '');
    }
    s = s || '整';
    n = Math.floor(n);
    for (let i = 0; i < unit[0].length && n > 0; i++) {
        let p = '';
        for (let j = 0; j < unit[1].length && n > 0; j++) {
            p = digit[n % 10] + unit[1][j] + p;
            n = Math.floor(n / 10);
        }
        s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
    }
    return s.replace(/(零.)*零元/, '元')
        .replace(/(零.)+/g, '零')
        .replace(/^整$/, '零元整');
};

// 數字千分化
export function handleThousands (value) {
    const suffix = ''
    if (value && value !== 'NULL' && value !== 'undefined' && isNaN(Number(value))) {
        return value
    } else if (!value) {
        return '0'
    } else {
        const pSuffix = ''
        value = value.toString()
        const intPart = Math.floor(Math.abs(Number(value)))
        let intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
        intPartFormat = pSuffix + intPartFormat
        let floatPart = ''
        const value2Array = value.split('.')

        if (value2Array.length === 2) {
            floatPart = value2Array[1].toString()
            if (floatPart.length === 1) {

                return intPartFormat + '.' + floatPart + '0' + suffix
            } else {
                return intPartFormat + '.' + floatPart + suffix
            }
        } else {
            return intPartFormat + floatPart + suffix
        }
    }
}

// 格式化時間
export function formatTime(num) {
    if(num.toString().length > 4) return num
    const str = num.toString().padStart(4, '0')
    const hours = str.slice(0, 2)
    const minutes = str.slice(2, 4)
    return `${hours}:${minutes}`
}


//根據時間相差多少
export function getTimeDiff(date,startDate,endDate) {
    let start = new Date(`${date} ${startDate}` )
    let end = new Date(`${date} ${endDate}`)
    let diffMs = end - start
    if (diffMs < 0) diffMs = 0
    const hours = Math.floor(diffMs / (1000 * 60 * 60))
    const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60))
    return `${hours}小時${minutes < 10 ? '0' + minutes : minutes}分鐘`
}
